'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cmfSenderToSenderMap, _senderToCmfSenderMap;

exports.fromCmfSender = fromCmfSender;
exports.toCmfSender = toCmfSender;

var _senderTypes = require('../../pubnub-message/constants/senderTypes');

var senderTypes = _interopRequireWildcard(_senderTypes);

var _cmfSenderTypes = require('../../common-message-format/constants/cmfSenderTypes');

var cmfSenderTypes = _interopRequireWildcard(_cmfSenderTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cmfSenderToSenderMapping = (_cmfSenderToSenderMap = {}, _defineProperty(_cmfSenderToSenderMap, cmfSenderTypes.AGENT_SENDER, senderTypes.AGENT), _defineProperty(_cmfSenderToSenderMap, cmfSenderTypes.VISITOR_SENDER, senderTypes.VISITOR), _defineProperty(_cmfSenderToSenderMap, cmfSenderTypes.BOT_SENDER, senderTypes.BOT), _defineProperty(_cmfSenderToSenderMap, cmfSenderTypes.SYSTEM_SENDER, senderTypes.SYSTEM), _defineProperty(_cmfSenderToSenderMap, cmfSenderTypes.VID_SENDER, senderTypes.VISITOR), _cmfSenderToSenderMap);

var senderToCmfSenderMapping = (_senderToCmfSenderMap = {}, _defineProperty(_senderToCmfSenderMap, senderTypes.AGENT, cmfSenderTypes.AGENT_SENDER), _defineProperty(_senderToCmfSenderMap, senderTypes.VISITOR, cmfSenderTypes.VISITOR_SENDER), _defineProperty(_senderToCmfSenderMap, senderTypes.BOT, cmfSenderTypes.BOT_SENDER), _defineProperty(_senderToCmfSenderMap, senderTypes.SYSTEM, cmfSenderTypes.SYSTEM_SENDER), _senderToCmfSenderMap);

/**
 *
 * @param {string} cmfSenderType
 * @returns {string} senderType
 */
function fromCmfSender(cmfSenderType) {
  return cmfSenderToSenderMapping[cmfSenderType];
}

/**
 *
 * @param {string} senderType
 * @returns {string} cmfSenderType
 */
function toCmfSender(senderType) {
  return senderToCmfSenderMapping[senderType];
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format-conversion/operators/cmfSenderInterop.js
// module id = 696
// module chunks = 2 3